export default __webpack_public_path__ + "static/media/table.9a1f7e0a.png";